
import { FC, useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { Source } from "@/services/frank/types";
import { DocumentInfo, fetchOrganizationDocuments } from "./DocumentMatcher";
import SourceItem from "./SourceItem";

interface SourcesSectionProps {
  sources: Source[];
}

const SourcesSection: FC<SourcesSectionProps> = ({ sources }) => {
  const [showSources, setShowSources] = useState(false);
  const [documents, setDocuments] = useState<DocumentInfo[]>([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  
  useEffect(() => {
    console.log("SourcesSection received sources:", JSON.stringify(sources, null, 2));
  }, [sources]);
  
  useEffect(() => {
    if (sources && sources.length > 0) {
      fetchDocuments();
    }
  }, [sources]);
  
  const fetchDocuments = async () => {
    setLoadingDocuments(true);
    try {
      const docs = await fetchOrganizationDocuments();
      setDocuments(docs);
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoadingDocuments(false);
    }
  };
  
  if (!sources || !Array.isArray(sources) || sources.length === 0) {
    console.log("No sources to display");
    return null;
  }
  
  return (
    <div className="mt-3 space-y-2 text-xs border-t border-[#637588]/20 pt-2">
      <div className="flex justify-between items-center">
        <p className="italic text-[#637588] text-xs">
          This response is based on information from your documents
        </p>
        <button 
          onClick={() => setShowSources(!showSources)}
          className="ml-2 flex items-center text-xs text-[#637588] hover:text-[#111418] transition-colors"
        >
          <span>See {showSources ? 'less' : 'more'}</span>
          <ChevronDown 
            className={`h-4 w-4 ml-1 transition-transform ${showSources ? 'rotate-180' : ''}`} 
          />
        </button>
      </div>
      
      {showSources && (
        <div className="animate-in fade-in-50 duration-150">
          {sources.map((source, index) => (
            <SourceItem 
              key={index} 
              source={source} 
              documents={documents} 
              loadingDocuments={loadingDocuments} 
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SourcesSection;
